const PROOF_TYPES = [
    { id: 'internet_bill', label: 'Recibo de internet' },
    { id: 'bank_account_statement', label: 'Estado de cuenta bancario' },
    { id: 'electricity_bill', label: 'Recibo de luz' },
    { id: 'phone_bill', label: 'Recibo telefónico' },
    { id: 'property_tax', label: 'Predial' },
    { id: 'water_bill', label: 'Recibo de agua' }
];
export default PROOF_TYPES;
